import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { onGetReportThunkV2 } from './DailyReport.actions'
import { CardComponent, CardRow } from '../../../components/Layouts/Card.styles'
import { DataTable } from '@carbon/icons-react'
import Card from '../../../components/Layouts/Card'
import Typography from '../../../components/Basics/Typography'
import { FirstRow, SecondRow, ThirdRow, FourthRow, FifthRow, SixthRow, SeventhRow, EighthRow } from './DailyReport.row'
import { Stack } from '@carbon/react'
import { Button, DatePicker, DatePickerInput, Dropdown } from '@carbon/react'
import { Export } from '@carbon/icons-react'
import DailyReportTable from './DailyReportTable.container'
import LoadingContent from '../../../components/Animations/LoadingContent'
import { useDatePicker, useDropdown } from '../../../components/Inputs/Inputs.hooks'
import { checkErrorRequired } from '../../../modules/errors/validations';

const getCurrentShift = () => {
  const now = new Date();
  const hours = now.getHours();

  // Turn A is from 08:00 to 19:59
  if (hours >= 8 && hours < 20) {
    return 'Turno Día';
  }

  // Turn B is from 20:00 to 07:59
  return 'Turno Noche';
};

/**
 * The Performance's container.
 */
const DailyReportContainerV2 = () => {
  const dispatch = useDispatch()
  const { error, loading, url } = useSelector(state => state.dailyTurn)
  const items = [
    { id: 'turno_dia', text: 'Turno Día' },
    { id: 'turno_noche', text: 'Turno Noche' }
  ]
  const [currentItem, setCurrentItem] = useState(items[0]);
  const today = new Date()
  const yesterday = new Date(today)
  yesterday.setDate(today.getDate() - 1)

  const { error: dateError, value: dateValue, onChange: handleDateChange } = useDatePicker({
    initialValue: [yesterday],
    errorCallbacks: [checkErrorRequired()]
  })

  const dispatchReport = (date) => {
    handleDateChange(date)
    dispatch(onGetReportThunkV2(date, currentItem?.id))
  }

  useEffect(() => {
    if (!loading) {
      return
    }
    dispatch(onGetReportThunkV2(undefined, currentItem?.id));
  }, [])
  const currentTurn = getCurrentShift()
  return (
    <>
      {loading && !error && (
        <LoadingContent />
      )}
      {!loading && error && (
        <>
          <DatePicker datePickerType="single" maxDate={yesterday.toISOString()} style={{ marginBottom: '40px' }} onChange={dispatchReport} value={dateValue} dateFormat='d-m-Y'>
            <DatePickerInput placeholder="dd/mm/yyyy" labelText="Fecha del Reporte" id="daily-datepicker-error" size="md" />
          </DatePicker>
          <Dropdown label='Seleccione Turno' style={{ width: '15%' }} id="turn-selector-error" titleText="Seleccione turno" items={items} itemToString={item => item ? item.text : ''} initialSelectedItem={items[0]} selectedItem={currentItem} onChange={({ selectedItem }) => setCurrentItem(selectedItem)} />
          <CardComponent width="10%">
            <Typography className='cds--type-heading-compact-01'>
              No hay datos para este dia
            </Typography>
          </CardComponent>
        </>
      )}
      {!loading && !error && (
        <Stack gap={3}>
          <DatePicker datePickerType="single" maxDate={yesterday.toISOString()} onChange={dispatchReport} value={dateValue} dateFormat='d-m-Y'>
            <DatePickerInput placeholder="dd/mm/yyyy" labelText="Fecha del Reporte" id="daily-datepicker" size="md" />
          </DatePicker>
          <Dropdown label='Seleccione Turno' style={{ width: '15%' }} id="turn-selector" titleText="Seleccione turno" items={items} itemToString={item => item ? item.text : ''} initialSelectedItem={items[0]} selectedItem={currentItem} onChange={({ selectedItem }) => setCurrentItem(selectedItem)} />
          <CardRow>
            <FirstRow />
          </CardRow>
          <CardRow>
            <SecondRow />
          </CardRow>
          <CardRow>
            <ThirdRow />
          </CardRow>
          {currentTurn === 'Turno Día' ? (
            <CardRow>
              <FourthRow />
            </CardRow>
          ) : (
            <CardRow>
              <FifthRow />
            </CardRow>
          )}
          <CardRow>
            <SixthRow />
          </CardRow>
          <CardRow>
            <SeventhRow />
          </CardRow>
          <CardRow>
            <EighthRow />
          </CardRow>
          <CardRow>
            <CardComponent width="100%">
              <Card justifyContent='flex-start' >
                <DataTable size={18} />
                <Typography className='cds--type-heading-compact-01'>
                  CAMIONES OPERATIVOS - TABLA DE DATOS
                </Typography>
              </Card>
              <CardRow width='inherit'>
                <Card width='100%' padding="0">
                  <DailyReportTable currentTurn={currentItem?.id} />
                </Card>
              </CardRow>
            </CardComponent>
          </CardRow>
        </Stack>
      )}

    </>
  )
}

export default DailyReportContainerV2
